import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";
import styles from "./styles/table.css.js";
import withStyles from "components/with-styles";
import CopyToClipboard from "components/copy-to-clipboard";
import TableRow from "@material-ui/core/TableRow";
import { HeaderCell } from "components/table";
import TableCell from "@material-ui/core/TableCell";
import { PaginatedTable } from "components/table";
import FormConfirm from "components/form/form-confirm";
import Icon from "components/icon";
import { ExternalLink } from "components/link";
import Dialog from "components/dialog";
import QRCode from "react-qr-code";
import { useImperativeTracking } from "components/tracking";

const Header = () => (
  <TableRow>
    <HeaderCell>
      <FormattedMessage id="event.fonts.table.name" />
    </HeaderCell>
    <HeaderCell>
      <FormattedMessage id="event.fonts.table.src" />
    </HeaderCell>
    <HeaderCell />
    <HeaderCell />
  </TableRow>
);

const RowComponent = ({ eventId, item, classes }) => {
  const track = useImperativeTracking();
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    track(`user copies font [${item.id}] with name [${item.name}] and larix url [${item.larixUrl}]`);
  };

  const handleOpenDialog = useCallback(
    e => {
      e.stopPropagation();
      track(`User opened larix QR dialog for [${item.id}]`);
      setOpen(true);
    },
    [item.id, track],
  );

  const handleCloseDialog = useCallback(
    e => {
      e.stopPropagation();
      track(`User closed larix QR dialog for [${item.id}]`);
      setOpen(false);
    },
    [item.id, track],
  );

  return (
    <TableRow key={item.id}>
      <TableCell>{item.name}</TableCell>
      <TableCell>
        <CopyToClipboard textToCopy={item.larixUrl} onClick={handleClick} />
      </TableCell>
      <TableCell>
        <ExternalLink className={classes.button} href={item.larixUrl}>
          <Icon name="launch" />
          <div className={classes.alignedLink__externalLink__text}>
            <FormattedMessage id="event.fonts.table.tool.openLarix" />
          </div>
        </ExternalLink>
      </TableCell>
      <TableCell>
        <div className={classes.alignedLink__externalLink} onClick={handleOpenDialog}>
          <Icon name="crop-free" />
          <div className={classes.alignedLink__externalLink__text}>
            <FormattedMessage id="event.fonts.table.tool.openQR" />
          </div>
        </div>
        <Dialog
          showModalClose={false}
          onClose={handleCloseDialog}
          showModalAccept={false}
          title=""
          open={open}
          onAccept={handleCloseDialog}
        >
          <QRCode value={item.larixUrl} size={300} />
        </Dialog>
      </TableCell>
    </TableRow>
  );
};

RowComponent.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
  /**
   ** Id del evento
   **/
  eventId: PropTypes.string,
};

const I18nStyledRowComponent = withStyles(styles)(RowComponent);

const InsertUrlsTable = ({ classes, event, intl, isCamera = false, ...props }) => {
  const fonts = event && event.infoBert && event.infoBert.remoteIngestions ? event.infoBert.remoteIngestions : [];
  const filteredFonts = fonts.filter(({ type }) => type === (isCamera ? "VIDEO+AUDIO" : "AUDIO-ONLY"));

  return filteredFonts && filteredFonts.length > 0 ? (
    <PaginatedTable
      className={classes.table}
      paginatedElements={{ items: filteredFonts, total: filteredFonts.length }}
      headerComponent={Header}
      rowComponent={I18nStyledRowComponent}
      showPagination={false}
      perPage={0}
      rowProps={{ eventId: event.id }}
    />
  ) : (
    <FormConfirm
      show
      label={intl.formatMessage({ id: isCamera ? "event.fonts.table.empty.video" : "event.fonts.table.empty.audio" })}
      warning
      className={classes.warning}
      hideCloseButton
    />
  );
};

InsertUrlsTable.propTypes = {
  /**
   * Evento
   */
  event: PropTypes.object,
  /**
   * Indica si es cámara o audio
   */
  isCamera: PropTypes.bool,
};

export default injectIntl(withStyles(styles)(InsertUrlsTable));
